export default __webpack_public_path__ + "static/onboarding3-f590cca6abec71c59ba125f2d39b3712.webp";